import { Component, OnInit, TemplateRef } from '@angular/core';
import { NotaDebitoService } from '../../../services/nota-debito.service';
import { NotaDebito } from '../../../models/nota-debito';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';
import { ConfigService } from '../../../config/config-service';
import { ReporteModalComponent } from '../../../components/modals/reporte-modal/reporte-modal.component';
import { ReenviarCorreoComponent } from '../../../components/modals/reenviar-correo/reenviar-correo.component';
import { NotadebitoModalComponent } from '../../../components/modals/notadebito-modal/notadebito-modal.component';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-nota-debito-list',
  templateUrl: './nota-debito-list.component.html',
  styleUrls: ['./nota-debito-list.component.css'],
  providers: [NotaDebitoService]
})
export class NotaDebitoListComponent implements OnInit {
  public notas: Array<NotaDebito>;
	public loading: boolean = false;
	public bsModalRef: BsModalRef;
	public bsModalRef2: BsModalRef;
	public msg: SweetMessage;
	public Mod_FactElec: string;
	public config: ConfigService;
	public nota_debito_anulada: NotaDebito;
	public observacion: String;
	public factelec_api: String;

	constructor(
		private notaDebitoService: NotaDebitoService,
		private modalService: BsModalService,
		private ss: SessionService,
	) {
		this.notas = [];
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.config = new ConfigService();
		this.factelec_api = environment.factelec_api;
	}

  	ngOnInit() {
		this.msg = new SweetMessage();
		let p1 = this.getNotasDebito();
		Promise.all([p1]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	getNotasDebito(){
		return new Promise((resolve, reject) => {
			this.notaDebitoService.getAll("?embed=tipocomprobante,estadobitacora,venta?embed=cliente").subscribe(
				res => {
					this.notas = res.data;
					resolve();
				},
				err => {
					this.notas = [];
					reject();
				}
			);
		});
	}

	getNumero(nota_debito: NotaDebito){
		return nota_debito.serie + "-" + nota_debito.punto_emision + "-" + nota_debito.secuencial;
	}

	onShow(id){
		const initialState = {nota_debito_id: id};
		this.bsModalRef = this.modalService.show(NotadebitoModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onPrint(id){
		/*const initialState = {nota_debito_id: id};
		this.bsModalRef = this.modalService.show(FacturaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));*/
	}

	onStatusElectronica(nota_debito){
		let msn = "";
		msn += "<p>Estado de Nota de Débito Electrónica</p>";
		msn += "<p><b style='font-size:24px;'>"+nota_debito.estadobitacora.descripcion+"</b></p>";
		this.msg.showMessage('single-message', msn);
	}

	OnReenviar(nota_debito){
      	const initialState = { nombre: nota_debito.venta.cliente.nombre_comercial, correo: nota_debito.venta.cliente.correo, autorizacion: nota_debito.numero_autorizacion };
	 	this.bsModalRef = this.modalService.show(ReenviarCorreoComponent, Object.assign({}, {initialState}));
  	}

	onReport(nota_debito){
    	const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/ride/" + nota_debito.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onXML(nota_debito){
		const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/xml/" + nota_debito.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	CodEst(nota_debito){
		let cod_ests = ['NAT', 'NFIR', 'NLOG', 'DEV', 'TOT', 'FEC'];
		let result = cod_ests.filter(cod_est => cod_est === nota_debito.cod_est);

		if( result.length > 0 ){
			return 'btn-danger';
		}

		cod_ests = ['VAL', 'PPR', 'EP'];
		result = cod_ests.filter(cod_est => cod_est === nota_debito.cod_est);

		if( result.length > 0 ){
			return 'btn-warning';
		}

		cod_ests = ['AUT'];
		result = cod_ests.filter(cod_est => cod_est === nota_debito.cod_est);

		if( result.length > 0 ){
			return 'btn-success';
		}
	}

	openModalObservacion(template: TemplateRef<any>, nota_debito: NotaDebito) {
		if(nota_debito.tipo_comprobante_id.toString() === "11"){
			let preg = "Recuerda que para anular algún comprobante primero debes anularlo desde <a href='https://declaraciones.sri.gob.ec/tuportal-internet/' target='_blank'>https://declaraciones.sri.gob.ec/tuportal-internet/</a>, posteriormente podrás anularlo desde esta opción. ¿Estás seguro que deseas continuar?";
			const initialState = { Pregunta: preg, Respuesta:false };
			this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
			
			this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
				if(Respuesta == true){
					this.observacion = nota_debito.observacion;
					this.nota_debito_anulada = nota_debito;
					this.bsModalRef = this.modalService.show(template);
					this.bsModalRef2 = this.bsModalRef;
				}
			});
		}
		else{
			this.observacion = nota_debito.observacion;
			this.nota_debito_anulada = nota_debito;
			this.bsModalRef = this.modalService.show(template);
			this.bsModalRef2 = this.bsModalRef;
		}
	}

	anularNota(){
		this.bsModalRef2.hide();
		let preg = "¿Está seguro de querer anular el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.nota_debito_anulada.observacion = this.observacion.toString().trim();
				this.nota_debito_anulada.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";
				
				this.loading = true;

				this.notaDebitoService.anular(this.nota_debito_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.nota_debito_anulada = new NotaDebito();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getNotasDebito().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/nota-debito-list/nota-debito-list.component.ts